import React from 'react';
import './GameHeader.css';

const GameHeader = ({ 
  title = "Cringe Quest",
  subtitle = "Select Your Fate: Your therapist will thank you later.",
  showSubtitle = true,
  titleClassName = "game-title",
  subtitleClassName = "game-subtitle"
}) => {
  // console.log('🎮 GameHeader - showSubtitle:', showSubtitle, 'subtitle:', subtitle);
  
  return (
    <div className="title-container">
      <div className="title-background"></div>
      <h1 className={titleClassName}>
        {title}
      </h1>
      {showSubtitle && (
        <h2 
          className={subtitleClassName}
          style={{
            position: 'relative',
            zIndex: 10
          }}
        >
          {subtitle}
        </h2>
      )}
    </div>
  );
};

export default GameHeader;
